import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { MainContentWrapper, MainContent, PageWrapper } from "./components/StyledComponents";
import BreadcrumbStructuredData from "./components/BreadcrumbStructuredData.js";
import Navbar from "./components/NavigationBar_tw.js";
import SimpleNavbar from "./components/SimpleNavbar.js"; // Import a simplified navbar component
import Home from "./components/pages/HomePage.js";
import Courses from "./components/pages/CoursesPage.js";
import Team from "./components/Team.js";
import Info from "./components/pages/InfoPage.js";
import Contact from "./components/pages/ContactPage.js";
//import Contact_slim from "./components/Contact_slim.js";
import Quiz from "./components/pages/QuizPage.js";
import QuizCarousel from "./components/pages/QuizCarouselPage.js";
import Footer from "./components/Footer.js";
import Datenschutz from "./components/pages/DatenschutzPage.js";
import Impressum from "./components/pages/ImpressumPage.js";
import FAQ from "./components/pages/FAQPage.js";
import "bootstrap/dist/css/bootstrap.min.css";
import CourseById from "./components/pages/CourseByIdPage.js";
import { UserProvider } from "./context/UserContext.js";
import UserTypeButton from "./components/UserTypeButton.js";
import CookieConsent from "./components/CookieConsent"; // CookieConsent component
import { trackPageView } from "./analytics"; // Import analytics tracking function
import PageBottom from './components/PageBottom';
import Jobs from "./components/pages/JobsPage.js";
import Promotions from "./components/pages/PromotionsPage.js";
//import PromoPopup from "./components/PromoPupUp.js";
import ScrollToTop from "./components/ScrollToTop.js";
import Preise from "./components/pages/PreisePage.js";
import ScrollTopButton from "./components/BackToTop.js";
import AGB from "./components/pages/AGBPage.js"
import Booking from "./components/pages/BookingPage.js";
import { BookingProvider } from './context/BookingContext';
import { Outlet } from 'react-router-dom';
import FallingBackground from "./components/FallingBackground.js";
import FunnelContactPage from "./components/funnelContact/FunnelContactPage.js";
import TrialSignupPage from "./components/funnelTrial/TrialSignupPage.js";

const BookingLayout = () => {
  return (
    <BookingProvider>
      <Outlet />
    </BookingProvider>
  );
};

// Component for tracking page views
const AnalyticsWrapper = ({ children }) => {
  const location = useLocation();

  React.useEffect(() => {
    trackPageView(location.pathname); // Track page view if consent is given
  }, [location]);

  return children;
};

// Navigation wrapper component that displays different navbars based on route
const NavigationWrapper = () => {
  const location = useLocation();
  const isLandingPage = location.pathname === '/start' || location.pathname === '/start/signup';
  
  return (
    <>
      {isLandingPage ? <SimpleNavbar /> : <Navbar />}
      {!isLandingPage && <UserTypeButton />}
    </>
  );
};

function App() {
  const svgImages = [
    '/backgroundSVGs/CS.svg'
  ];

  return (
    <UserProvider>
      <PageWrapper>
      <FallingBackground 
          svgCount={10} 
          minSpeed={15} 
          maxSpeed={35} 
          svgImages={svgImages}
          minSize={100}
          maxSize={120}
        />
        <Router>
          <ScrollToTop />
          <BreadcrumbStructuredData />
          <NavigationWrapper />
          <AnalyticsWrapper>
            <MainContentWrapper>
              <MainContent>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route element={<BookingLayout />}>
                    <Route path="/preise" element={<Preise />} />
                    <Route path="/courses" element={<Courses />} />
                    <Route path="/courses/:id" element={<CourseById />} />
                    <Route path="/booking" element={<Booking />} />
                  </Route>
                  <Route path="/team" element={<Team />} />
                  <Route path="/info" element={<Info />} />
                  <Route path="/quiz" element={<Quiz />} />
                  <Route path="/quizCarousel" element={<QuizCarousel />} />
                  <Route path="/contact" element={<Contact/>} />
                  <Route path="/datenschutz" element={<Datenschutz />} />
                  <Route path="/impressum" element={<Impressum />} />
                  <Route path="/faq" element={<FAQ />} />
                  <Route path="/jobs" element={<Jobs />} />
                  <Route path="/promo" element={<Promotions />} />
                  <Route path="/agb" element={<AGB />} />
                  <Route path="/start" element={<FunnelContactPage />} />
                  <Route path="/start/signup" element={<TrialSignupPage />} />
                </Routes>
              </MainContent>
              
              <ScrollTopButton />
              <PageBottom />
            </MainContentWrapper>
          </AnalyticsWrapper>
          <CookieConsent />

          <Footer />
        </Router>
      </PageWrapper>
    </UserProvider>
  );
}

export default App;